import {Competition} from "./eventTypes";

export interface Permission {
    id: string;
    name: string;
    entity: string;
    operation: string;
}

export interface Role {
    id: string;
    name: string;
    description: string;
    permissions: Permission[];
}

export interface User {
    id: string;
    name: string;
    surname: string;
    username: string;
    email: string;
    password?: string;
    roles: Role[];
    organizations?: Organization[];
    competitions?: Competition[];
}

export interface Team {
    id: string;
    name: string;
    official_name: string;
    short_name: string;
    external_id: string;
    logo_url: string;
}

export interface UserResponse {
    session_token: string | undefined,
    user: User
}

export enum UserRole {
    User = "user",
    Admin = "admin",
    SuperAdmin = "super-admin"
}

export interface Organization {
    id: string;
    name: string;
    users: User[];
    competitions: Competition[];
    teams: {id: string}[];
}